module.exports = __webpack_public_path__ + "static/media/mgz.63f4f46d.svg";